(function() {
  "use strict";
  angular.module("marketPlace.association", []);
})();
